/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  hotel: 'hotel',
  destination: 'destination',
  tripsFound: 'tripsFound',
  from: 'from',
  noPackagesFoundInformation: 'noPackagesFoundInformation',
  onContinueLoadingText: 'onContinueLoadingText',
  allDestinations: 'allDestinations'
}; export default Keys;